import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  HttpClient,
  HttpClientModule
} from '@angular/common/http';
import { ConfigService } from './shared/services/config/config.service';
import { initSentry } from './shared/services/logger.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GraphqlModule } from './shared/services/graphql/graphql.module';
import { OverlayModule } from '@angular/cdk/overlay';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AuthGuard, ComponentsGalleryGuard } from './shared';
import { TasksService } from './shared/services/tasks/tasks.service';
import { LoggerService } from './shared/services/logger.service';
import { MatNativeDateModule } from '@angular/material/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { provideApolloClientOptions } from '../graphql/client';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import localeCs from '@angular/common/locales/cs';
import { interceptorProviders } from './shared/interceptors/interceptor-provider';
import { AuthApiV2Module } from './shared/services/auth-api-v2/auth-api-v2.module';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import * as Sentry from '@sentry/angular';
import { ConfigModule } from './shared/services/config/config.module';
registerLocaleData(localeCs);

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  // TODO: better cache by version
  return new TranslateHttpLoader(
    http,
    '/assets/i18n/',
    '.json?v=' + Date.now()
  );
}

const matFormFieldDefaultOptions: MatFormFieldDefaultOptions = {
  hideRequiredMarker: true
};

export function initializeAppFactory(configService: ConfigService) {
  return async (): Promise<void> => {
    await configService.loadConfig();
    initSentry(configService);
  };
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    AuthApiV2Module,
    BrowserModule,
    ConfigModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    GraphqlModule,
    MatNativeDateModule,
    MatDialogModule,
    MatIconModule,
    MatToolbarModule,
    CommonModule,
    HttpClientModule,
    OverlayModule,
    MatSnackBarModule,
    NgbModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    AuthGuard,
    ComponentsGalleryGuard,
    TasksService,
    LoggerService,
    { provide: LOCALE_ID, useValue: 'cs-CS' },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [ConfigService],
      multi: true
    },
    {
      provide: APOLLO_OPTIONS,
      useFactory: provideApolloClientOptions,
      deps: [HttpLink, ConfigService],
    },
    interceptorProviders,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: matFormFieldDefaultOptions
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
